/**
 * @generated SignedSource<<3b158d3ad33966447c2d22ae19c631b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactFirstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactLastName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contactEmail",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initialBalanceAmount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoTopupActive",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rAutoTopupActive",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoTopupAmount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rAutoTopupAmount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoTopupThreshhold",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rAutoTopupThreshold",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxMonthlyBudget",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rMaxMonthlyBudget",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxCharge",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rMaxCharge",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "preApproveSubs",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rPreApproveSubs",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetApprovedCount",
  "storageKey": null
},
v23 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "projectId",
        "variableName": "projectId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  }
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "walletId",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoTopupThreshold",
  "storageKey": null
},
v29 = [
  (v27/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v28/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userName",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userRole",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userArole",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userConfirmDate",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "termsAcceptDate",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "auth0Uid",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountStatus",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personaStatus",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psType",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "psStatus",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAppId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appId",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAccountId",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appStatus",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSkuPrice",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appMarkupAbsolute",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appMarkupPercentage",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentOrder",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passThroughFees",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rPaymentOrder",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rPassThroughFees",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rAppMarkupPercentage",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bcId",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bcStatus",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sharedEmail",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pwd",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSubscription",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appName",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appSku",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appUrl",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appLogo",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appType",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signupUrl",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "AppT",
  "kind": "LinkedField",
  "name": "appTByAppId",
  "plural": false,
  "selections": [
    (v61/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    (v65/*: any*/),
    (v66/*: any*/),
    (v67/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "soEntered",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "soAccepted",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceStatus",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v73 = [
  (v27/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v28/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v72/*: any*/)
],
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "AppT",
  "kind": "LinkedField",
  "name": "appTByAppId",
  "plural": false,
  "selections": [
    (v61/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    (v65/*: any*/),
    (v66/*: any*/),
    (v67/*: any*/),
    (v72/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StepEmailTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "ProjectTsConnection",
            "kind": "LinkedField",
            "name": "projectTsByCustomerAccountId",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WalletT",
                    "kind": "LinkedField",
                    "name": "walletTByCustomerWalletId",
                    "plural": false,
                    "selections": (v29/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WalletT",
                    "kind": "LinkedField",
                    "name": "walletTByResellerWalletId",
                    "plural": false,
                    "selections": (v29/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserTsConnection",
            "kind": "LinkedField",
            "name": "userTsByAccountId",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByParentId",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSourceTsConnection",
            "kind": "LinkedField",
            "name": "paymentSourceTsByAccountId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentSourceT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v42/*: any*/),
                  (v43/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "CustomerAppTsConnection",
            "kind": "LinkedField",
            "name": "customerAppTsByCustomerAccountId",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerAppT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v44/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BindCardT",
                    "kind": "LinkedField",
                    "name": "bindCardTByBcId",
                    "plural": false,
                    "selections": [
                      (v57/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v58/*: any*/),
                  (v59/*: any*/),
                  (v60/*: any*/),
                  (v68/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "CustomerServiceTsConnection",
            "kind": "LinkedField",
            "name": "customerServiceTsByCustomerAccountId",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerServiceT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v69/*: any*/),
                  (v70/*: any*/),
                  (v71/*: any*/),
                  (v68/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StepEmailTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountT",
        "kind": "LinkedField",
        "name": "accountTByAccountId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "ProjectTsConnection",
            "kind": "LinkedField",
            "name": "projectTsByCustomerAccountId",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WalletT",
                    "kind": "LinkedField",
                    "name": "walletTByCustomerWalletId",
                    "plural": false,
                    "selections": (v73/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WalletT",
                    "kind": "LinkedField",
                    "name": "walletTByResellerWalletId",
                    "plural": false,
                    "selections": (v73/*: any*/),
                    "storageKey": null
                  },
                  (v72/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserTsConnection",
            "kind": "LinkedField",
            "name": "userTsByAccountId",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v72/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByParentId",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v72/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSourceTsConnection",
            "kind": "LinkedField",
            "name": "paymentSourceTsByAccountId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PaymentSourceT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v42/*: any*/),
                  (v43/*: any*/),
                  (v72/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "CustomerAppTsConnection",
            "kind": "LinkedField",
            "name": "customerAppTsByCustomerAccountId",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerAppT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v44/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BindCardT",
                    "kind": "LinkedField",
                    "name": "bindCardTByBcId",
                    "plural": false,
                    "selections": [
                      (v57/*: any*/),
                      (v72/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v58/*: any*/),
                  (v59/*: any*/),
                  (v60/*: any*/),
                  (v74/*: any*/),
                  (v72/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "CustomerServiceTsConnection",
            "kind": "LinkedField",
            "name": "customerServiceTsByCustomerAccountId",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomerServiceT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v69/*: any*/),
                  (v70/*: any*/),
                  (v71/*: any*/),
                  (v74/*: any*/),
                  (v72/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v72/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fc8891077afa7ee162a1164c1bd747fc",
    "id": null,
    "metadata": {},
    "name": "StepEmailTemplateQuery",
    "operationKind": "query",
    "text": "query StepEmailTemplateQuery(\n  $accountId: UUID!\n  $projectId: UUID\n) {\n  accountTByAccountId(accountId: $accountId) {\n    accountId\n    accountName\n    logo\n    contactFirstName\n    contactLastName\n    contactEmail\n    accountType\n    initialBalanceAmount\n    autoTopupActive\n    rAutoTopupActive\n    autoTopupAmount\n    rAutoTopupAmount\n    autoTopupThreshhold\n    rAutoTopupThreshold\n    maxMonthlyBudget\n    rMaxMonthlyBudget\n    maxCharge\n    rMaxCharge\n    preApproveSubs\n    rPreApproveSubs\n    budgetApprovedCount\n    projectTsByCustomerAccountId(condition: {projectId: $projectId}) {\n      totalCount\n      nodes {\n        projectId\n        projectName\n        preApproveSubs\n        rPreApproveSubs\n        budgetApprovedCount\n        walletTByCustomerWalletId {\n          walletId\n          initialBalanceAmount\n          autoTopupActive\n          rAutoTopupActive\n          autoTopupAmount\n          rAutoTopupAmount\n          autoTopupThreshold\n          rAutoTopupThreshold\n          maxMonthlyBudget\n          rMaxMonthlyBudget\n          nodeId\n        }\n        walletTByResellerWalletId {\n          walletId\n          initialBalanceAmount\n          autoTopupActive\n          rAutoTopupActive\n          autoTopupAmount\n          rAutoTopupAmount\n          autoTopupThreshold\n          rAutoTopupThreshold\n          maxMonthlyBudget\n          rMaxMonthlyBudget\n          nodeId\n        }\n        nodeId\n      }\n    }\n    userTsByAccountId {\n      totalCount\n      nodes {\n        userId\n        userName\n        userRole\n        lastName\n        firstName\n        email\n        userArole\n        userConfirmDate\n        termsAcceptDate\n        auth0Uid\n        nodeId\n      }\n    }\n    accountTByParentId {\n      accountName\n      accountId\n      contactFirstName\n      contactLastName\n      contactEmail\n      accountStatus\n      personaStatus\n      nodeId\n    }\n    paymentSourceTsByAccountId {\n      nodes {\n        psType\n        psStatus\n        nodeId\n      }\n    }\n    customerAppTsByCustomerAccountId(condition: {projectId: $projectId}) {\n      totalCount\n      nodes {\n        customerAppId\n        appId\n        customerAccountId\n        appStatus\n        appSkuPrice\n        appMarkupAbsolute\n        appMarkupPercentage\n        paymentOrder\n        passThroughFees\n        rPaymentOrder\n        rPassThroughFees\n        rAppMarkupPercentage\n        bcId\n        bindCardTByBcId {\n          bcStatus\n          nodeId\n        }\n        sharedEmail\n        pwd\n        showSubscription\n        appTByAppId {\n          appName\n          appSku\n          appUrl\n          appLogo\n          appType\n          description\n          signupUrl\n          nodeId\n        }\n        nodeId\n      }\n    }\n    customerServiceTsByCustomerAccountId(condition: {projectId: $projectId}) {\n      totalCount\n      nodes {\n        soEntered\n        soAccepted\n        serviceStatus\n        appTByAppId {\n          appName\n          appSku\n          appUrl\n          appLogo\n          appType\n          description\n          signupUrl\n          nodeId\n        }\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "40483d0071c1e58e16cab3d8fcacff04";

module.exports = node;
